//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
import priceTp from '@/components/page-temporary/priceTp'
export default {
  name: "price-list",
  components: {
    divSpan,
    priceTp
  },
  data() {
    return {
      tabIndex: 1,
      refresh:true,
      wrapperHeight: 0,
      allLoaded: false,
      config: {
        title: '价格信息库',
        url: 'api/priceMasterData/page',
        workflowSearchBean: {},
        tabList:['ERP价格库','SRM价格库'],
        fixRules:{},
        inputCondition: {
          placeholder: '物料编号/名称',
          searchCondition: 'key',
          rules: [{
            field: "material.matCode-material.matName",
            option: "LIKE_ANYWHERE"
          }]
        },
        selectConfig: [
          {
            list: [{name: '全部', code: null},{name: '标准', code: '0'},{name: '委外', code: '1'}],
            text: '采购类型',
            type: 'selector',
            rules: [{field: "prcType", option: "IN"}]
          },
          {
            text: '采购组织',
            type: 'search',
            condition: 'purOrg',
            searchCondition: {label: 'purorgName', code: 'purorgCode'},
            rules: [{field: "purorg.purorgName-purorg.purorgCode", option: "LIKE_ANYWHERE"}],
          },
          {
            text: '工厂',
            type: 'search',
            condition: 'plant',
            searchCondition: {label: 'plantName', code: 'plantCode'},
            rules: [{field: "plant.plantCode-plant.plantName", option: "LIKE_ANYWHERE"}],
          },
        ]
      },
      configTodo: {
        title: '价格信息库',
        url: 'api/purPrice/page',
        workflowSearchBean: {},
        fixRules:{},
        inputCondition: {
          placeholder: '物料编号/名称',
          searchCondition: 'key',
          rules: [{
            field: "material.matCode-material.matName",
            option: "LIKE_ANYWHERE"
          }]
        },
        selectConfig: [
          {
            list: [{name: '全部', code: null},{name: '标准', code:'0'},{name: '委外', code: 'L'},{name: '寄售采购', code: 'K'}],
            text: '采购类型',
            type: 'selector',
            rules: [{field: "materialType", option: "IN"}]
          },
          {
            text: '采购组织',
            type: 'search',
            condition: 'purOrg',
            searchCondition: {label: 'purorgName', code: 'purorgCode'},
            rules: [{field: "purorg.purorgName-purorg.purorgCode", option: "LIKE_ANYWHERE"}],
          },
          {
            text: '工厂',
            type: 'search',
            condition: 'plant',
            searchCondition: {label: 'plantName', code: 'plantCode'},
            rules: [{field: "plant.plantCode-plant.plantName", option: "LIKE_ANYWHERE"}],
          },
        ]
      },
      searchData: {},
      list: [],
      showMore: true
    }
  },
  methods: {
    goDetail(id){
      this.$router.push('/srm-price-view/'+id);
    },
    getTabIndex(e) {
      this.tabIndex = e;
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop() {
      this.$refs.header.getlist(true);
    },
    loadBottom() {
      this.$refs.header.getMore();
    },
  },
  mounted() {
    this.init();
    this.$refs.header.tabIndex = this.$route.query.tabIndex || 1;
    this.tabIndex = this.$route.query.tabIndex || 1;
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/price-library/erp-price-library.vue